import { CxEvent } from '@spartacus/core'
import { MbConstants } from '../../shared/mb-constants'

export class PoUploadSuccess extends CxEvent {
  static readonly type = 'PoUploadSuccessEvent'
  event?: Event
  poUploadStatus = MbConstants.PO_UPLOAD_SUCCESS
}

export class PoUploadFailed extends CxEvent {
  static readonly type = 'PoUploadFailedEvent'
  event?: Event
  poUploadStatus = MbConstants.PO_UPLOAD_FAILED
}

